import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { XdsIconButtonComponent } from 'src/app/shared/ui/icon-button/icon-button.component';

/**
 * Daumen-hoch/-runter unter einer Assistant-Bubble. Nach einer Antwort
 * wird disabled + Dankes-Text gezeigt.
 */
@Component({
  selector: 'app-help-feedback-buttons',
  standalone: true,
  imports: [CommonModule, TranslateModule, XdsIconButtonComponent],
  template: `
    <div class="fb" *ngIf="!submitted">
      <span class="fb__prompt">{{ 'HELP_CHAT.FEEDBACK.PROMPT' | translate }}</span>
      <xds-icon-button
        size="sm"
        variant="ghost"
        icon="fa-light fa-thumbs-up"
        [ariaLabel]="'HELP_CHAT.FEEDBACK.PROMPT' | translate"
        (clicked)="rate(true)"
      ></xds-icon-button>
      <xds-icon-button
        size="sm"
        variant="ghost"
        icon="fa-light fa-thumbs-down"
        [ariaLabel]="'HELP_CHAT.FEEDBACK.PROMPT' | translate"
        (clicked)="rate(false)"
      ></xds-icon-button>
    </div>
    <small class="fb__thanks" *ngIf="submitted">
      {{
        (lastHelpful ? 'HELP_CHAT.FEEDBACK.THANKS_POSITIVE' : 'HELP_CHAT.FEEDBACK.THANKS_NEGATIVE')
          | translate
      }}
    </small>
  `,
  styles: [
    `
      .fb {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-top: 4px;
      }
      .fb__prompt {
        font-size: 12px;
        color: var(--clr-text-200, #6f7782);
        margin-right: 4px;
      }
      .fb__thanks {
        display: block;
        font-size: 12px;
        color: var(--clr-text-200, #6f7782);
        margin-top: 4px;
      }
    `,
  ],
})
export class HelpFeedbackButtonsComponent {
  @Input() feedbackId: string | null = null;
  @Output() rated = new EventEmitter<{ feedbackId: string; helpful: boolean }>();

  protected submitted = false;
  protected lastHelpful = false;

  protected rate(helpful: boolean): void {
    if (!this.feedbackId || this.submitted) return;
    this.lastHelpful = helpful;
    this.submitted = true;
    this.rated.emit({ feedbackId: this.feedbackId, helpful });
  }
}
